"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RootRef.default;
  }
});

var _RootRef = _interopRequireDefault(require("./RootRef"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/RootRef/index.js
// module id = 314
// module chunks = 0